import React, { type ChangeEvent, useEffect, useMemo, useState } from "react";

import SearchIcon from "@mui/icons-material/Search";
import { InputBase, Stack } from "@mui/material";
import { debounce } from "lodash";

import { useNewsFeed } from "../context/NewsFeedContext";

const SEARCH_DEBOUNCE_MS = 500;

export const Search: React.FC = () => {
  const { filters, setFilters } = useNewsFeed();

  const [localSearch, setLocalSearch] = useState(filters.search);

  useEffect(() => {
    setLocalSearch((curr) => (curr === filters.search ? curr : filters.search));
  }, [filters.search]);

  const debouncedSetSearch = useMemo(
    () => debounce((search: string) => setFilters((prev) => ({ ...prev, search })), SEARCH_DEBOUNCE_MS),
    [setFilters]
  );

  useEffect(() => () => debouncedSetSearch.cancel(), [debouncedSetSearch]);

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="4px"
      sx={{
        width: "167px",
        px: "8px",
        py: "4px",
        borderRadius: "128px",
        border: "1px solid #7B92A9",
        bgcolor: "#fff",
        height: "26px"
      }}
    >
      <SearchIcon sx={{ fontSize: 16, color: "#92A7BC", flexShrink: 0 }} />
      <InputBase
        placeholder="Search..."
        value={localSearch}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          setLocalSearch(e.target.value);
          debouncedSetSearch(e.target.value);
        }}
        sx={{
          flex: 1,
          minWidth: 0,
          fontSize: "14px",
          lineHeight: "16px",
          color: "#071F35",
          "& .MuiInputBase-input": {
            p: 0,
            "&::placeholder": { color: "#92A7BC", opacity: 1 }
          }
        }}
      />
    </Stack>
  );
};
